import { AdminPanelSettingsOutlined, Engineering, LockOpenOutlined, LockOutlined, SecurityOutlined } from '@mui/icons-material';
import { Box, Typography, useMediaQuery } from '@mui/material';

const UsersColumns = () => {
    const isMobile = useMediaQuery('(max-width:600px)');

    const renderAccessPill = (enabled, label) => (
        <Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
        <Box
            className={`hive-grid-role-pill hive-grid-role-pill--${enabled ? 'allowed' : 'denied'}`}
            width={`${isMobile ? '80%' : '70%'}`}
            m="0 auto"
            p="5px"
            display="flex"
            justifyContent="center"
            alignItems="center"
            backgroundColor={enabled ? "#3da58a" : "#c53939"}
            borderRadius="4px"
        >
            {enabled ? <LockOpenOutlined /> : <LockOutlined />}
            <Typography className="hive-grid-role-pill__text" color={"#e0e0e0"} sx={{ ml: "5px" }}>{label}</Typography>
        </Box>
        </Box>
    );

    return [
        { field: "isActive", headerName: "Status", width: 105, valueGetter: (value) => value === false ? "Inactive" : "Active" },
        {
            field: "firstName",
            headerName: "Name",
            flex: 1,
            cellClassName: "name-column--cell",
            renderCell: ({row: { firstName, lastName }}) => `${firstName} ${lastName}`
        },
        // -- Conditionally show/hide columns -- //
        ...(isMobile ? [] : [
            {
                field: "email",
                headerName: "Email",
                flex: 1,
            },
            {
                field: "department",
                headerName: "Department",
                flex: 1,
            },
        ]),
        {
            field: "role",
            headerName: "Role",
            flex: 1,
            renderCell: ({ row: { role } }) => {
                return (
                    <Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
                    <Box
                        className={`hive-grid-role-pill hive-grid-role-pill--${role}`}
                        width={`${isMobile ? '80%' : '60%'}`}
                        m="0 auto"
                        p="5px"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        backgroundColor={
                            role === "admin" ?
                            "#3da58a" :
                            role === "manager" ? "#c53939"
                            : role === "engineer" ? "#3ec9d6"
                            : "#4680ff"
                        }
                        borderRadius="4px"
                    >
                        {role === "admin" && <AdminPanelSettingsOutlined />}
                        {role === "manager" && <SecurityOutlined />}
                        {role === "user" && <LockOpenOutlined />}
                        {role === "engineer" && <Engineering/> }
                        <Typography className="hive-grid-role-pill__text" color={"#e0e0e0"} sx={{ ml: "5px" }}>{role}</Typography>
                    </Box>
                    </Box>
                );
            },
        },
        ...(isMobile ? [] : [
            {
                field: "canAuditAllChats",
                headerName: "Audit Chats",
                flex: 0.8,
                renderCell: ({ row: { canAuditAllChats } }) => renderAccessPill(!!canAuditAllChats, canAuditAllChats ? "Enabled" : "Disabled")
            }
        ]),
    ];
};

export default UsersColumns
